import { getUserAvailableBonuses, userDeposit } from "@actions/bonus";
import Loading from "@components/loading/index.jsx";
import Alert from "@pages/profile-v2/pages/bonuses/components/Alert";
import NoContent from "@pages/profile-v2/pages/history-v2/components/NoContent";
import debounce from "lodash/debounce";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { BonusWrapper } from "../../elements";
import BonusItem, { getFreespinGameData } from "./BonusItem";
import PaginationWrapper from "./Pagination/index";

const Pending = ({
	getUserAvailableBonuses,
	offsetToken,
	userDeposit,
	bonusList,
	translate,
	loading,
}) => {
	const rootRef = useRef(null);
	const [openIndex, setOpenIndex] = useState(-1);
	const [page, setPage] = useState(0);
	const [alertData, setAlertData] = useState({
		open: false,
		type: "freespin",
		data: null,
	});

	useEffect(() => {
		fetchBonuses();
	}, [getUserAvailableBonuses]);

	const fetchBonuses = () => {
		getUserAvailableBonuses({ params: { size: 25 } }, () => {});
	};

	const onPaginate = (page, cb) => {
		if (offsetToken === undefined || !!offsetToken) {
			getUserAvailableBonuses({ params: { size: 25, offset: offsetToken } }, () => {
				if (cb) cb();
			});
			setPage(page);
		}
	};

	const onConfirm = (item) => {
		try {
			userDeposit(item.bonusId, item.timestamp, () => {
				fetchBonuses(false);
				setAlertData({
					open: true,
					type: item.bonusDetail.instruction.type,
					data:
						item.bonusDetail.instruction.type === "Freespin"
							? { game: getFreespinGameData(item.bonusDetail.limits)?.games[0] }
							: null,
				});
			});
		} catch (error) {
			console.error(error);
		}
	};

	const handleCloseAlert = () => {
		setAlertData({ ...alertData, open: false });
	};

	const validBonuses = bonusList?.filter((b) => {
		const now = moment();
		const endDate = moment(Number(b?.timestamp)).add(
			b?.bonusDetail?.claimExpirationDays,
			"days"
		);
		return endDate.isAfter(now);
	});

	if (validBonuses?.length === 0 && alertData.open === false) {
		return (
			<NoContent
				translate={translate}
				title={"NoInfoText"}
				description={"NoInfoBonus"}
				noBackground={true}
			/>
		);
	}

	return (
		<>
			{loading && <Loading loading />}
			<Alert
				type={alertData.type}
				open={alertData.open}
				data={alertData}
				onClose={handleCloseAlert}
			/>
			<div
				style={{ width: "100%" }}
				ref={rootRef}>
				<PaginationWrapper
					initialBind={true}
					root={rootRef}
					page={page}
					onPaginate={onPaginate}>
					<BonusWrapper>
						{validBonuses
							.filter((b) => !b.isDisabled)
							.map((item, index) => (
								<BonusItem
									key={index}
									index={index}
									data={item}
									onConfirm={debounce(onConfirm, 300)}
									openIndex={openIndex}
									setOpenIndex={setOpenIndex}
									loading={loading}
									translate={translate}
								/>
							))}
					</BonusWrapper>
				</PaginationWrapper>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	bonusList: state.bonus.userAvailableBonuses,
	loading: state.bonus.userAvailableBonusesLoading,
	offsetToken: state.bonus.userAvailableBonusesOffset,
	listEnd: state.bonus.listEnd,
});

const mapDispatchToProps = {
	getUserAvailableBonuses,
	userDeposit,
};

export default connect(mapStateToProps, mapDispatchToProps)(Pending);
